import React from 'react'
import FacebookIcon from '@material-ui/icons/Facebook'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import GitHubIcon from '@material-ui/icons/GitHub'
import BugReportIcon from '@material-ui/icons/BugReport'
import {AssignmentOutlined, WebOutlined} from '@material-ui/icons'
import AccountBalanceSharpIcon from '@material-ui/icons/AccountBalanceSharp'
import WebIcon from '@material-ui/icons/Web'
import AdminDash from '../assets/bootstrap/admin.png'
import Car from '../assets/bootstrap/Car.png'
import Furniture from '../assets/bootstrap/Furniture.png'
import Grandmas from '../assets/bootstrap/Grandmas_sweet_store.png'
import Music from '../assets/bootstrap/Music_lover.png'
import Sushi from '../assets/bootstrap/Sushi_monstar.png'
import Portfolio from '../assets/bootstrap/Toy_portfolio.png'
import Toy_web from '../assets/bootstrap/Toy_web_project.png'
import Rent from '../assets/bootstrap/Renting_house.png'
import Coctails from '../assets/reactBasic/coctails.png'
import Experience from '../assets/reactBasic/experience.png'
import Ourmenu from '../assets/reactBasic/ourmenu.png'
import OurTour from '../assets/reactBasic/ourTours.png'
import Question from '../assets/reactBasic/question.png'
import Reviewer from '../assets/reactBasic/reviewer.png'
import Subnavbar from '../assets/reactBasic/subnavbar.png'
import Grocery from '../assets/reactBasic/grocery.png'
import Darkmode from '../assets/reactAdv/darkmode.png'
import HackerNews from '../assets/reactAdv/hackerNews.png'
import Pagination from '../assets/reactAdv/pagination.png'
import Quiz from '../assets/reactAdv/quiz.png'
import Random from '../assets/reactAdv/random.png'
import GithubUser from '../assets/largeScale/github.png'
import Webbrain from '../assets/largeScale/webbrain.png'
import Cvmine from '../assets/largeScale/cvmine.png'
import Boots from '../assets/certificates/bootstrap.jpeg'
import Ecma from '../assets/certificates/ecma.jpeg'
import Ecma2 from '../assets/certificates/ecma2.jpeg'
import Js from '../assets/certificates/js.jpeg'
import ModernJs from '../assets/certificates/modernJs.jpeg'
import Coursera from '../assets/certificates/coursera.png'
import Patent1 from '../assets/certificates/patent1.png'
import Patent2 from '../assets/certificates/patent2.png'
import Pub1 from '../assets/certificates/pub1.png'
import Pub2 from '../assets/certificates/pub2.png'
import Transcr from '../assets/certificates/transcr.png'
import Research from '../assets/certificates/research.png'
import Research2 from '../assets/certificates/research2.png'
import Research3 from '../assets/certificates/research3.png'
import Topik from '../assets/certificates/topik.png'
import CV from '../assets/cv/fayozbek.pdf'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: 'Fayozbek Rustamov',
  title: 'Front-End Developer & Security Analyser',
  resume: `${CV}`,
  about:
    'I am a scientist who is positive about every aspect of life. My greatest strength is taking initiative in my research work, good leadership, staff motivation, and development and my weakness is that I am not satisfied until my research work do not complete',
  birthday: '1990',
  degree: 'Ph.D.',
  country: 'Uzbekistan',
  email: 'f.f.rustamov@gmail.com',
  phone: '(+82)10-7777-7777',
  address: 'Seoul, South Korea',

  mailto: {
    subject: '',
    body: '',
  },

  emailJS: {
    serviceId: 'service_mytypm7',
    templateId: 'template_qv082vj',
    userId: 'user_3apeZB2s5d9yLvNtsiHvS',
  },

  socials: {
    LinkedIn: {
      url: 'https://www.linkedin.com/in/fayozbek-rustamov-80b422178/',
      text: 'Fayozbek Rustamov',
      icon: <LinkedInIcon />,
    },
    GitHub: {
      url: 'https://github.com/FBek90',
      text: 'FBek90',
      icon: <GitHubIcon />,
    },
    Facebook: {
      url: 'https://m.facebook.com/#!/bek.rustamov.167',
      text: 'Fayozbek Rustamov',
      icon: <FacebookIcon />,
    },
    Researchgate: {
      url: 'https://www.researchgate.net/profile/Fayozbek-Rustamov',
      text: 'Fayozbek Rustamov',
      icon: <AccountBalanceSharpIcon />,
    },
  },
  experiences: [
    {
      title: 'Teacher',
      date: '09/2015 - 09/2016,',
      description: `Tashkent University of Information Technologies, Tashkent Uzbekistan`,
    },
    {
      title: 'PhD Researcher in Security AI LAB (R&D), Sejong University',
      date: '09/2016-09/2021',
      description: `Search-based software vulnerability automatic detection
technology`,
    },
    {
      title: 'Teaching Assistant at Sejong University',
      date: '09/2016-09/2021',
      description: `Courses: Software Analysis and Secure Coding/Network Security`,
    },
    {
      title: 'Web Developer (Intern) in Web Brain Academy',
      date: '03/2021 - Present',
      description: `Contact: https://www.linkedin.com/in/smd94/`,
    },
  ],
  patents: [
    {
      title: 'Software vulnerability analysis device and method',
      date: '03/2019',
      description: 'Patent number: 10-1963752',
    },
  ],
  languages: [
    {
      title: 'English',
      description: 'Professional Working Proficiency',
    },
    {
      title: 'Korean (TOPIK II-4th level)',
      description: 'Professional Working Proficiency',
    },
    {
      title: 'Russian',
      description: 'Limited Working Proficiency',
    },
    {
      title: 'Uzbek',
      description: 'Native or Bilingual Proficiency',
    },
  ],
  interests: [
    {
      title: 'Traveling',
    },
    {
      title: 'Cooking',
    },
    {
      title: 'Swimming',
    },
    {
      title: 'Reading Books',
    },
  ],
  educations: [
    {
      title: 'Bachelor in Economics And Management In the Sphere Of ICT',
      date: '09/2009 - 07/2013',
      description:
        'Tashkent University of Information Technologies, Tashkent, Uzbekistan (GPA: 4.5)',
    },
    {
      title:
        'Masters in Computer Engineering(Information Security Cryptography and Cryptanalysis)',
      date: '09/2013 - 07/2015',
      description:
        'Tashkent University of Information Technologies, Tashkent, Uzbekistan (GPA: 4.5)',
    },
    {
      title: 'Ph.D. in Computer and Information Security',
      date: '09/2016 - 09/2021',
      description: 'Sejong University, Seoul, South Korea (GPA: 4.1)',
    },
    {
      title: 'Front-End Development',
      date: '02/2021 - 07/2021',
      description: 'WebBrain Academy (Online Bootcamp)',
    },
  ],
  certifications: [
    {
      title: 'Beruniy',
      date: '2013',
      description:
        'The Ministry of Higher and Secondary Special Education of the Republic of Uzbekistan',
    },
    {
      title: 'Scholarship of “Uzbekiston Pochtasi"',
      date: '2013',
      description: `Open Joint-Stock Company “Uzbekiston Pochtasi”`,
    },
    {
      title: 'Young Scientist',
      date: '2014',
      description: `The Ministry of Development of Information Technologies and Communications of the Republic of Uzbekistan`,
    },
  ],
  services: [
    {
      title: 'Web Development',
      description: 'I have been working on web design for 1 years.',
      icon: <WebOutlined />,
    },
    {
      title: 'Branding Identity',
      description:
        'We will make you a brand that is catchy and leaves a trace.',
      icon: <AssignmentOutlined />,
    },
    {
      title: 'Bug Hunting',
      description:
        'I have been working on software testing (Fuzzing) for 3 years.',
      icon: <BugReportIcon />,
    },
  ],
  skills: [
    {
      title: 'FRONT-END',
      description: ['ReactJS', 'JavaScript (ES6)', 'Bootstrap', 'Material UI'],
    },
    {
      title: 'REVERSING',
      description: ['IDA Pro', 'Binary Ninja', 'Binary Analayzing'],
    },
    {
      title: 'SOFTWARE TESTING',
      description: ['AFL', 'Angr', 'Driller', 'Fuzzing'],
    },
    {
      title: 'SOURCE CONTROL',
      description: ['Git', 'GitHub'],
    },
  ],
  publications: [
    {
      title: 'Efficient block cipher mode for NVM (published)',
      date: 'May 2018',
      description: 'DOI: 10.1088/1742-6596/1026/1/012005',
      link: 'https://www.researchgate.net/publication/325562784_Efficient_block_cipher_mode_for_NVM',
    },
    {
      title:
        'Search-Based Concolic Execution for SW Vulnerability Discovery (published)',
      date: 'October 2018',
      description: 'DOI: 10.1587/transinf.2018EDL8052',
      link: 'https://www.researchgate.net/publication/328002856_Search-Based_Concolic_Execution_for_SW_Vulnerability_Discovery',
    },
    {
      title:
        'DeepDiver: Diving into Abysmal Depth of the Binary for Hunting Deeply Hidden Software Vulnerabilities (published)',
      date: 'April 2020',
      description: 'DOI: 10.3390/fi12040074',
      link: 'https://www.researchgate.net/publication/340755845_DeepDiver_Diving_into_Abysmal_Depth_of_the_Binary_for_Hunting_Deeply_Hidden_Software_Vulnerabilities',
    },
    {
      title:
        'BugMiner: Mining the Hard-to-Reach Software Vulnerabilities through the Target-Oriented Hybrid Fuzzer (published)',
      date: 'December 2020',
      description: 'DOI: 10.3390/electronics10010062',
      link: 'https://www.researchgate.net/publication/348096234_BugMiner_Mining_the_Hard-to-Reach_Software_Vulnerabilities_through_the_Target-Oriented_Hybrid_Fuzzer',
    },
    {
      title:
        'FIRM-COV: High-Coverage Greybox Fuzzing for IoT Firmware via Optimized Process Emulation (published)',
      date: 'July 2021',
      description: 'DOI: 10.1109/ACCESS.2021.3097807',
      link: 'https://www.researchgate.net/publication/353468054_FIRM-COV_High-Coverage_Greybox_Fuzzing_for_IoT_Firmware_via_Optimized_Process_Emulation',
    },
    {
      title:
        'Combining Fuzzing with Concolic Execution for IoT Firmware Testing (published)',
      date: 'June 2021',
      description: 'AsiaCCS 2021',
      link: 'https://asiaccs2021.comp.polyu.edu.hk/',
    },
    {
      title: 'A Survey of Embedded System Fuzzing (under review)',
      date: 'January 2021',
      description: 'ACM Computing Surveys',
      link: 'https://dl.acm.org/journal/csur',
    },

    {
      title:
        'Exploratory Review on the Hybrid Fuzzing for Automated Vulnerability Detection (under review)',
      date: 'September 2021',
      description: 'IEEE Access',
      link: 'https://ieeeaccess.ieee.org/',
    },
    {
      title:
        'Target-Oriented Hybrid fuzzing for detecting deeply hidden software bugs (Ph.D. thesis)',
      date: 'June 2021',
      description: 'Sejong Data Collection',
      link: 'http://sejong.dcollection.net/',
    },
  ],
  //   PROJECTS
  portfolio: [
    // Bootstrap
    {
      tag: 'Bootstrap',
      image: `${AdminDash}`,
      title: 'Admin Dashboard',
      caption: '',
      description: 'This is a responsible bootstrap project',
      tech: 'HTML5/CSS3/Bootstrap4',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/Bootstrap_projects/tree/master/admin_project',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-bs-admin.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'Bootstrap',
      image: `${Car}`,
      title: 'Car seller',
      caption: '',
      description: 'This is a responsible bootstrap project',
      tech: 'HTML5/CSS3/Bootstrap4',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/Bootstrap_projects/tree/master/car_project',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-bs-car.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'Bootstrap',
      image: `${Furniture}`,
      title: 'Furniture',
      caption: '',
      description: 'This is a responsible bootstrap project',
      tech: 'HTML5/CSS3/Bootstrap4',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/Bootstrap_projects/tree/master/furniture',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-bs-furniture.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'Bootstrap',
      image: `${Grandmas}`,
      title: 'Sweet store',
      caption: '',
      description: 'This is a responsible bootstrap project',
      tech: 'HTML5/CSS3/Bootstrap4',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/Bootstrap_projects',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-bs-sweet.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'Bootstrap',
      image: `${Music}`,
      title: 'Music Lover',
      caption: '',
      description: 'This is a responsible bootstrap project',
      tech: 'HTML5/CSS3/Bootstrap4',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/Bootstrap_projects/tree/master/music_app',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-bs-music.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'Bootstrap',
      image: `${Rent}`,
      title: 'Houzing',
      caption: '',
      description: 'This is a responsible bootstrap project',
      tech: 'HTML5/CSS3/Bootstrap4',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/Bootstrap_projects/tree/master/renters',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-bs-renters.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'Bootstrap',
      image: `${Sushi}`,
      title: 'Sushi Monstar',
      caption: '',
      description: 'This is a responsible bootstrap project',
      tech: 'HTML5/CSS3/Bootstrap4',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/Bootstrap_projects/tree/master/restaurant',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-bs-restaurant.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'Bootstrap',
      image: `${Portfolio}`,
      title: 'Toy Portfolio',
      caption: '',
      description: 'This is a responsible bootstrap project',
      tech: 'HTML5/CSS3/Bootstrap4',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/Bootstrap_projects/tree/master/Portfolio_project',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-bs-portfolio.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'Bootstrap',
      image: `${Toy_web}`,
      title: 'Toy Web Project',
      caption: '',
      description: 'This is a responsible bootstrap project',
      tech: 'HTML5/CSS3/Bootstrap4',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/Bootstrap_projects/tree/master/landing_page',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-bs-myfirstweb.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },

    // REact basic
    {
      tag: 'React (Basic)',
      image: `${Coctails}`,
      title: 'Search Coctails',
      caption: '',
      description: 'This is a responsible basic react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/15-cocktails',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactbasic-coctails.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (Basic)',
      image: `${Experience}`,
      title: 'Experience',
      caption: '',
      description: 'This is a responsible basic react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/06-tabs',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactbasic-tab.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (Basic)',
      image: `${Ourmenu}`,
      title: 'Our Menu',
      caption: '',
      description: 'This is a responsible basic react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/05-menu',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactbasic-menu.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (Basic)',
      image: `${OurTour}`,
      title: 'Our Tour',
      caption: '',
      description: 'This is a responsible basic react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/02-tours',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactbasic-tour.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (Basic)',
      image: `${Question}`,
      title: 'Question & Answers',
      caption: '',
      description: 'This is a responsible basic react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/04-accordion',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactbasic-accardion.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (Basic)',
      image: `${Reviewer}`,
      title: 'Our Reviewers',
      caption: '',
      description: 'This is a responsible basic react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/03-reviews',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactbasic-slider.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (Basic)',
      image: `${Subnavbar}`,
      title: 'Sub Navbar',
      caption: '',
      description: 'This is a responsible basic react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/13-stripe-submenus',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactbasic-submenu.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (Basic)',
      image: `${Grocery}`,
      title: 'My Grocery',
      caption: '',
      description: 'This is a responsible basic react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/10-grocery-bud',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactbasic-grocery.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    // React advanced
    {
      tag: 'React (Advanced)',
      image: `${Darkmode}`,
      title: 'Darkmode',
      caption: '',
      description: 'This is a responsible a bit complex react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/20-dark-mode',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactadvanced-darkmode.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (Advanced)',
      image: `${HackerNews}`,
      title: 'Hacker News',
      caption: '',
      description: 'This is a responsible a bit complex react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/22-hacker-news',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactadvanced-hack.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (Advanced)',
      image: `${Pagination}`,
      title: 'Pagination',
      caption: '',
      description: 'This is a responsible a bit complex react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/18-pagination',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactadvanced-pagination.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (Advanced)',
      image: `${Quiz}`,
      title: 'Quiz',
      caption: '',
      description: 'This is a responsible a bit complex react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/23-quiz',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactadvanced-quiz.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (Advanced)',
      image: `${Random}`,
      title: 'Random Users',
      caption: '',
      description: 'This is a responsible a bit complex react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/react_basic_projects/tree/master/17-random-person',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-reactadvanced-random.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    // Large scale
    {
      tag: 'React (LargeScale)',
      image: `${GithubUser}`,
      title: 'Github Users Info',
      caption: '',
      description: 'This is a responsible and large scale react project',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://github.com/FBek90/GithubUserProject',
          icon: <GitHubIcon />,
        },
        {
          link: 'https://fayoz-react-search-github-users.netlify.app/',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (LargeScale)',
      image: `${Webbrain}`,
      title: 'WebBrain Academy',
      caption: '',
      description:
        'This is a large scale react project that clone th ant.design cite',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://wbba.netlify.app',
          icon: <WebIcon />,
        },
      ],
    },
    {
      tag: 'React (LargeScale)',
      image: `${Cvmine}`,
      title: 'My Portfolio',
      caption: '',
      description:
        'This is a large scale react project that illustrate my experience',
      tech: 'JavaScript/React.js',
      //   technology: {
      //     name: 'faceboorrk',
      //     icon: `${React1}`,
      //   },
      links: [
        {
          link: 'https://fayozbek-portfolio.netlify.app', //portfolio is added
          icon: <WebIcon />,
        },
      ],
    },
  ],

  //   Certificates

  certificate: [
    {
      tag: 'Bootstrap',
      image: `${Boots}`,
      title: 'Bootstrap',
      description: '"Bootstrap 4 Tutorial and 10 Projects" on Udemy (44 hours)',
    },
    {
      tag: 'JavaScript',
      image: `${Js}`,
      title: 'JavaScript',
      description: '"JavaScript Tutorial and Projects" on Udemy (40 hours)',
    },
    {
      tag: 'JavaScript',
      image: `${ModernJs}`,
      title: 'JavaScript',
      description: '"Modern JavaScript from Beginning" on Udemy (21.5 hours)',
    },
    {
      tag: 'JavaScript',
      image: `${Ecma}`,
      title: 'EcmaScript6/7/8/',
      description:
        '"ES6/7/8 Time to update your JavaScript EcmaScript" on Udemy (13 hours)',
    },
    {
      tag: 'JavaScript',
      image: `${Ecma2}`,
      title: 'EcmaScript6',
      description: '"Accelerated ES6 JavaScript Training" on Udemy (6 hours)',
    },
    {
      tag: 'React',
      image: `${Coursera}`,
      title: 'Coursera',
      description: '"Front-End Web development with React" on Coursera',
    },
    {
      tag: 'Patent',
      image: `${Patent1}`,
      title: 'Patent',
      description: '"Patent: Software vulnerability detecting" ',
    },
    {
      tag: 'Patent',
      image: `${Patent2}`,
      title: 'Patent Info',
      description: '"Patent: Software vulnerability detecting" ',
    },
    {
      tag: 'Study',
      image: `${Pub1}`,
      title: 'Electronics',
      description: 'BugMiner Manuscript',
    },
    {
      tag: 'Study',
      image: `${Pub2}`,
      title: 'Future Internet',
      description: 'DeepDiver Manuscript',
    },
    {
      tag: 'Study',
      image: `${Transcr}`,
      title: 'GPA',
      description: 'Study Scores and GPA: 4.1',
    },
    {
      tag: 'Study',
      image: `${Research}`,
      title: 'Science',
      description: 'Research Ethics for Research Manager',
    },
    {
      tag: 'Study',
      image: `${Research2}`,
      title: 'Science',
      description: 'Research Ethics for Graduate Students',
    },
    {
      tag: 'Study',
      image: `${Research3}`,
      title: 'Science',
      description: 'Understanding Korea`s Science and Technology Policy',
    },
    {
      tag: 'Topik II',
      image: `${Topik}`,
      title: 'Topik II',
      description: 'Score: 174 out of 300 (4급 out of 6급)',
    },
  ],
}
